import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {featurePoints_template} from "../components/templates/featurePoints_template";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class featurePoints extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected featurePointsTemplate: featurePoints_template;
    protected firstLoad = true;

    protected getModuleName(){
        return "featurePoints";
    }

    buildContent() : Array<Element>{

        this.featurePointsTemplate = new featurePoints_template( "featurePoints", this.viewModel, this );
        this.template = this.featurePointsTemplate;

        return [this.featurePointsTemplate.build()];
    }

    public fillPage() : void{
        this.getListFormData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/featurePoints/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();

    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsTemplate.validationsList.clearMessages();
                obj.updateFilters(responseParsed);
                //console.log(obj);
                obj.updateViewModelFromPath();
                obj.getListData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.featurePointsTemplate.builtTemplate);
            }
        };
    }

    public updateReportData(): void{

        this.loadingIn(this.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));
        this.featurePointsTemplate.getTemplateViewModel().isChartLoading(1);
        this.featurePointsTemplate.hideExportButton();
        this.featurePointsTemplate.resetData();

        let baseApiUrl: string = '/api/featurePoints/update/';

        this.sendFilterCall(baseApiUrl, {}, this.onDataUpdateRequestReturn, XMLHttpRequestHandler_requestType.POST, 'updateData');
    }

    public onDataUpdateRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Jira data updated successfully!");
                obj.getVnAppZone().showNotificationToModule();
                obj.getListData();
            });
        };
    }

    public getListData(): void{

        this.loadingIn(this.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));
        this.featurePointsTemplate.getTemplateViewModel().isChartLoading(1);
        this.featurePointsTemplate.hideExportButton();
        this.featurePointsTemplate.resetData();

        let subViewModel = this.featurePointsTemplate.getViewModelForRequest();
        let baseApiUrl: string = '/api/featurePoints/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsTemplate.validationsList.clearMessages();
                obj.updateList(responseParsed);

                if (obj.featurePointsTemplate.getTemplateViewModel().viewModeSelected() == "dashboard"){

                    obj.getIssueData();
                }
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.featurePointsTemplate.getTemplateViewModel().isChartLoading(0);
                obj.loadingOut(obj.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    public getIssueData(): void{

        this.loadingIn(this.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.featurePointsTemplate.getViewModelForRequest();
        let baseApiUrl: string = '/api/featurePoints/getDashboardTaskList/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onIssueDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getIssueData');
    }

    protected onIssueDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsTemplate.validationsList.clearMessages();
                obj.featurePointsTemplate.setIssuesData(responseParsed.issuesData);
                obj.featurePointsTemplate.updatePagination(responseParsed.totalCount);
                obj.featurePointsTemplate.showExportButton();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    public getIssuesDataForCSV(): void{

        this.loadingIn(this.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.featurePointsTemplate.getViewModelForRequest();

        let usrReq_url: string = '/api/featurePoints/getDashboardTaskListCSV';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onCSVIssuesDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCSVIssuesDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsTemplate.validationsList.clearMessages();
                obj.featurePointsTemplate.setCsvExportData(responseParsed.issuesData);
                obj.featurePointsTemplate.exportCsvData();
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.featurePointsTemplate.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected updateFilters(responseParsed: any) {

        this.featurePointsTemplate.setYearsFilterItems(responseParsed.years);
        this.featurePointsTemplate.setSingleYearsItems(responseParsed.years);
        this.featurePointsTemplate.setProjectsFilterItems(responseParsed.projects);
        this.featurePointsTemplate.setDepartmentsFilterItems(responseParsed.departments);
        this.featurePointsTemplate.setAssigneesFilterItems(responseParsed.assignees);
        this.featurePointsTemplate.setPendingStatuses(responseParsed.pendingStatuses);
        this.featurePointsTemplate.setViewModesItems();
        this.featurePointsTemplate.setQuartersItems();

        this.featurePointsTemplate.setDefaultSelectedFilters();
    }

    protected updateList(responseParsed: any) {

        this.featurePointsTemplate.resetData();

        if (this.featurePointsTemplate.getTemplateViewModel().viewModeSelected() == "quarterly"){

            if (this.firstLoad){

            }
            this.featurePointsTemplate.updateQuarterlyGraphData(responseParsed.graphLinesInfo,responseParsed.data);

        }else if (this.featurePointsTemplate.getTemplateViewModel().viewModeSelected() == "dashboard") {

            this.featurePointsTemplate.updateDashboardGraphData(responseParsed.graphLinesInfo,responseParsed.data);
        }else {

        }

        this.firstLoad = false;
    }

    protected config(){

        page('/feature_points/config/view');
    }

    protected filterMultipleSelectorOnChange() {

        this.getListData();
    }

    protected filterDateOnChange() {

        this.getListData();
    }

    protected filterSimpleOnChange() {

        this.getListData();
    }

    public filterDropdownOnChange(){

        this.getListData();
    }

    protected paginationOnPageClick(){

        this.getIssueData();
    }

    public listReorder(){

        this.getIssueData();
    }
}



// WEBPACK FOOTER //
// ./js/modules/featurePoints.ts